var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.serviceType.formComponent,{tag:"component",attrs:{"application":_vm.builder,"service":_vm.defaultValues.service,"loading":_vm.workflowActionLoading,"default-values":_vm.defaultValues.service},on:{"values-changed":function($event){_vm.values.service = { ..._vm.workflowAction.service, ...$event }}}})
}
var staticRenderFns = []

export { render, staticRenderFns }